import { Patient } from "types/patient";
import { calculateAge, formatBirthDate } from "utils/date";
import { formatPatientName } from "utils/patient";

import { PatientDetailData } from "../detail";

export const transformPatientToDetailData = (
  patient: Patient
): PatientDetailData => {
  return {
    id: patient.patientId,
    name: formatPatientName(patient),
    patientId: patient.patientId,
    age: calculateAge(patient.birthDate),
    gender: patient.gender || "N/A",
    email: patient.email || "N/A",
    status: patient.status,
    personalInfo: {
      dateOfBirth: patient.birthDate
        ? formatBirthDate(patient.birthDate)
        : "N/A",
      phone: patient.phone ? patient.phone : "N/A",
      address: "123 Street, New York",
      emergencyContact: "+123 456 678 (Wife)",
    },
    medicalInfo: {
      bloodType: "AB+",
      allergies: "Peanuts",
      conditions: "Type 2 Diabetes",
      insuranceStatus: "Active",
    },
    billingInfo: {
      billingStatus: "Due in 1 Day",
      payment: "$124",
      paymentType: "N/A",
      paymentProfile: "N/A",
    },
    appointments: [
      {
        id: "nIfZzcIayfSmYM2tRUfoWaUgXygW",
        title: "Follow-up",
        time: "10:00 AM",
        date: "15-07-2025",
        doctor: "Dr. Sarah Johnson",
        status: "Pending",
      },
      {
        id: "2",
        title: "Check-up",
        time: "08:00 AM",
        date: "12-07-2025",
        doctor: "Dr. Sarah Johnson",
        status: "Completed",
      },
    ],
  };
};
